import type { IconDef } from '../types';

export const facebook: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M9.46263 21L9.43636 13.125H6V9.75H9.43636V7.5C9.43636 4.4634 11.351 3 14.1091 3C15.4303 3 16.5657 3.0966 16.8966 3.13978V6.3132L14.9838 6.31406C13.4837 6.31406 13.1933 7.01411 13.1933 8.04139V9.75H17.4545L16.3091 13.125H13.1933V21H9.46263Z',
    },
  ],
};
